import React from 'react'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import '@babel/polyfill'
import 'isomorphic-fetch'

import { isMobile } from '../common/util'
import PhoneFrame from './PhoneFrame'

import './index.scss'
import App from './App'
import AppState from './state'

function useHashRouter() {
  return (
    AppState.isEmbedded() ||
    document.location.pathname === '/pwa.html' ||
    document.location.pathname === '/pwa_embedded.html'
  )
}

const PWA: React.FC<any> = props => {
  const app = useHashRouter() ? (
    <HashRouter>
      <App {...props} />
    </HashRouter>
  ) : (
    <BrowserRouter>
      <App {...props} />
    </BrowserRouter>
  )

  return AppState.isEmbedded() || isMobile() ? app : <PhoneFrame>{app}</PhoneFrame>
}

export default PWA
